import React , {useEffect,useState} from 'react';
import BackButton from './SVG/backButton';
import LogoCellcom from './SVG/logoCellcom.svg';
import Config from '../../../../Config';
import {loginStep} from './variables';
import Image from '../../../Shared/Image/image';
import {connect} from 'react-redux';
import { LogoHelper, LogoType } from 'app/utilities/LogoHelper/helper';
import { backHistory } from 'app/utilities/authentication/authenticationSlice';
const LoginHeader = (props) => {
  const [displayBackButton, setDisplayBackButton] = useState(false);
  const [stepHistory, setStepHistory] = useState([]);
  useEffect(() => {
    var history =JSON.parse(sessionStorage.getItem('stateHistoryStack::authentication'));
    setStepHistory(history);
    var displayBack = history?.length > 1 || window.history.length > 1;
    setDisplayBackButton(displayBack);
  }, [ props.authentication.loginStep]);

  const handleBackClick = () => {
    const hash = window.location.hash.replaceAll('#', '');
    const isEntranceStep = hash == loginStep.PHONE || hash == '';
    const isNotAuthenticated =
      !props.authentication.loginData?.isFullAuthenticated &&
      !props.authentication.loginData?.isOtpAuthenticated &&
      !props.authentication.loginData?.isOtpExtendedAuthenticated;

    if (isNotAuthenticated) {
      if (stepHistory?.length > 1) {
        props.backHistory();
      } else {
        window.history.back();
      }
      return;
    }

    props.backHistory();
  };

  const siteLogo = LogoHelper.getLogo(LogoType.SiteLogo);
  return (
    <div className='headerContainer'>
      <div className='header'>
        {displayBackButton && <BackButton onClick={handleBackClick} />}
        <Image
          src={siteLogo}
          onClick={() => {
            window.location.href = Config.staticWebSiteUrl;
          }}
        />
      </div>
      {props.children}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    backHistory: () => dispatch(backHistory()),
  };
};

export default connect(null, mapDispatchToProps)(LoginHeader);
